/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.actionBar.cropImage": "Redigera",
  "i18n.actionBar.removeImage": "Ta bort",
  "i18n.actionBar.swapImage": "Byt ut",
  "i18n.additionalInfoItemLayers.smartSorted.new": "NY!",
  "i18n.additionalProducts.addToCart": "Lägg till beställning",
  "i18n.additionalProducts.frame.description": "Högkvalitativ aluminiumram: silver matt, äkta glas, behöver inte limmas",
  "i18n.additionalProducts.frame.emotionalHook": "♥️ Tips:",
  "i18n.additionalProducts.frame.subtitle": "Det färdiga pusslet är ett fantastiskt minne – med vår <b>ram</b> framhävs det perfekt.",
  "i18n.additionalProducts.frame2023.description": "Högkvalitativ ram av träfiber – enkel att montera, utan glas, inklusive pussellim",
  "i18n.additionalProducts.framePlastic.description": "Högkvalitativ aluminiumram: silver matt, syntetiskt glas med antireflexbeläggning, behöver inte limmas",
  "i18n.additionalProducts.glue.description": "För upp till två 1000-bitars pussel, inklusive appliceringssvamp",
  "i18n.additionalProducts.glue.hook": "Så att ditt pussel blir en bild.\nFäster och skyddar på lång sikt.",
  "i18n.additionalProducts.roll.description": "För pussel från 48 till 2000 bitar",
  "i18n.additionalProducts.roll.hook": "Inget ledigt bord? Inget Problem.\nRulla ihop pusslet, förvara det och fortsätt senare.",
  "i18n.adventCalendarOverlay.activate": "Visa 24-luckor-förhandsgranskning",
  "i18n.adventCalendarOverlay.deactivate": "Dölj 24-luckor-förhandsgranskning",
  "i18n.adventCalendarOverlay.notice": "( Siffrorna och linjerna trycks inte med)",
  "i18n.button.addToCart": "Lägg i kundvagn",
  "i18n.button.apply": "Tillämpa",
  "i18n.button.back": "Tillbaka",
  "i18n.button.cancel": "Avbryt",
  "i18n.button.cancelAndFix": "Redigera nu",
  "i18n.button.chooseSmartSorted": "Välj SMART SORTED",
  "i18n.button.close": "Stäng",
  "i18n.button.continue": "Fortsätt",
  "i18n.button.createNewTextPlaceholders": "Skriv din text ",
  "i18n.button.ignore": "Ignorera",
  "i18n.button.ignoreAndContinue": "Fortsätt ändå",
  "i18n.button.mobile.createNewTextPlaceholders": "Text",
  "i18n.button.noChanges": "Ingen förändring",
  "i18n.button.ok": "Okej",
  "i18n.button.photos": "Foton",
  "i18n.button.retry": "Försök igen",
  "i18n.button.uploadPhotos": "Ladda upp foto(n)",
  "i18n.button.withSmartSorted": "Med SMART SORTED",
  "i18n.button.withoutSmartSorted": "Utan SMART SORTED",
  "i18n.control.colorChooser.color": "Färg",
  "i18n.control.fontChooser.placeholderText": "Typsnitt",
  "i18n.control.imageQuality.checkImages": "Kontrollera bildupplösning",
  "i18n.control.imageQuality.imageSuitability": "Bildkvalitet:",
  "i18n.control.imageQuality.indicatorAltText": "Bildkvalitet",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.templateChooser.title": "Välj design",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Korta ner texten för att öka läsbarheten.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "Det valda typsnittet är för stort för den här texten.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "Maximalt typsnitt för texten har uppnåtts.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "Minimalt typsnitt för texten har uppnåtts.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Korta ner texten för att öka läsbarheten.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Vänligen infoga en radbrytning",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Kontrollera din text, inte alla tecken stöds av denna typsnitt.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "Det maximala antalet tecken har uppnåtts ",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Korta ner texten för att öka läsbarheten.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Vänligen förstöra upp textfältet",
  "i18n.dialog.deletePlaceholder.message": "Det här steget kan inte ångras",
  "i18n.dialog.deletePlaceholder.title": "Verkligen ta bort platshållare?",
  "i18n.dialog.error.title": [
    "Det uppstod ett fel",
    "Något har gått fel"
  ],
  "i18n.dialog.insufficientImageQuality.message": "Bildens upplösning är för låg för att skriva ut motivet optimalt!",
  "i18n.dialog.smartSorted.message": "Med SMART SORTED kan du lägga ditt motiv med 1000 bitar på ett innovativt och enkelt sätt, även utan en motivmall.",
  "i18n.dialog.smartSorted.title": "Garanterat framgångsrik pusselupplevelse",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Klicka på \"{{text}}\", för att redigera lådtiteln.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "Lådtiteln har inte redigerats",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Fortsätt utan lådtitel",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "Mata in ett foto genom att klicka på platshållaren",
    "Mata in foton genom att klicka på platshållarna"
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "En platshållare är fortfarande tom",
    "En del platshållare är fortfarande tomma"
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "En platshållare har inte redigerats",
    "En del platshållare har inte redigerats."
  ],
  "i18n.dialog.unchangedPlaceholders.misc.message": [
    "Klicka på foto- eller textplatshållaren för att redigera ditt collage",
    "Klicka på foto- eller textplatshållarna för att redigera ditt collage"
  ],
  "i18n.dialog.unchangedPlaceholders.misc.title": [
    "En platshållare har inte redigerats",
    "En del platshållare har inte redigerats"
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "Klicka på textplatshållaren för att redigera texten",
    "Klicka på textplatshållarna för att redigera texterna"
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "En textplatshållare har inte redigerats",
    "En del textplatshållare har inte redigerats"
  ],
  "i18n.dialog.unchangedPlaceholders.title": "icke redigerade platshållare",
  "i18n.error.additionalInfoItemsError.message": "loading error information layer",
  "i18n.error.additionalInfoItemsError.title": "Laddningsfel",
  "i18n.error.deprecatedBrowserError.message": "Webbläsaren du använder stöds inte längre. Vänligen uppdatera den till en nyare version.",
  "i18n.error.deprecatedBrowserError.title": " ",
  "i18n.error.designerExpiredError.message": "Du har pausat designen under en längre tid. Det går inte att fortsätta. Vänligen starta processen igen.",
  "i18n.error.designerExpiredError.title": "Design färdigställd.",
  "i18n.error.fontLoadingError.message": "En typsnitt kunde inte laddas",
  "i18n.error.fontLoadingError.title": "Laddningsfel",
  "i18n.error.imageLoadingError.message": "Ett foto kunde inte laddas upp.  Det har exkluderats från galleriet och designprocessen.",
  "i18n.error.imageLoadingError.title": "Nedladdningsfel",
  "i18n.error.imageProvisionError.message": "Ett eller flera foton kunde inte bearbetas. Detta beror antagligen på att den valda medietypen inte stöds av systemet.",
  "i18n.error.imageProvisionError.title": "Ett foto kunde inte bearbetas",
  "i18n.error.imageSelectionError.message": "Filen \"{{reference1}}\" kunde inte bearbetas.",
  "i18n.error.imageSelectionError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.imageSizeLimitExceededError.message": "Bilden du har laddad upp är för stor.\nVänligen förminska bilden till mindre än 180 megapixlar och ladda upp den igen.",
  "i18n.error.imageSizeLimitExceededError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.imageUploadError.message": "Problem med internetanslutningen. \nVänligen försök igen senare.",
  "i18n.error.imageUploadError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.inlineSVGLoadingError.message": "Toleransramen\"{{reference1}}\" kunde inte laddas.",
  "i18n.error.inlineSVGLoadingError.title": "Nedladdningsfel",
  "i18n.error.invalidCharConfigError.message": "Denna typsnitt är inte tillämplig, välj en annan typsnitt.",
  "i18n.error.invalidCharConfigError.title": "Typsnitt inte tillämpligt",
  "i18n.error.malformedProductError.message": "En eller flera produkter kunde inte överföras till servern. Kanske är produkten inte längre tillgänglig eller produktdesignen tog för lång tid. Vi beklagar detta. Vänligen börja om designen.",
  "i18n.error.malformedProductError.title": "Överföringsfel",
  "i18n.error.notInStockError.message": "Produkten du har valt är för närvarande inte tillgänglig.\nKlicka på vår logotyp längst upp till vänster för att komma till startsidan. Där kan du välja en annan produkt.",
  "i18n.error.notInStockError.title": " ",
  "i18n.error.offlineNotice": "Det verkar som att din internetanslutning kopplades ner. Du kan fortsätta designa dina produkter så snart anslutningen har återställts.",
  "i18n.error.templateLoadingError.message": "Mallen \"{{ error.reference[0] }}\" kunde inte laddas.\nVänligen försök igen senare.",
  "i18n.error.templateLoadingError.title": "Nedladdningsfel",
  "i18n.error.transformationError.message": "Ändringen kunde inte genomföras ",
  "i18n.error.transformationError.title": "Ändringsfel",
  "i18n.error.traudlLoadingError.message": "Försök igen eller använd en annan bild.",
  "i18n.error.traudlLoadingError.title": "Det gick inte att använda ett AI-filter.",
  "i18n.error.unsupportedMediaTypeError.message": "\"{{reference1}}\"  innehåller en otillåten medietyp.",
  "i18n.error.unsupportedMediaTypeError.title": "Det uppstod ett fel under uppladdningsprocessen",
  "i18n.error.uploadProductError.message": "En eller flera produkter kunde inte överföras till servern. Vänligen försök igen senare.",
  "i18n.error.uploadProductError.title": "Överföringsfel",
  "i18n.error.zoomModeError.message": "Texten från din tidigare layout kunde inte antas. Vänligen ange en ny text.",
  "i18n.error.zoomModeError.title": "Text inte antagen",
  "i18n.gallery.uploadPhotos.info": "Vänligen klicka på knappen \"Ladda upp foto(n)\"",
  "i18n.gallery.uploadProgress": [
    "Laddar upp foto ...",
    "Uppladdade foton: {{current}} av {{total}}"
  ],
  "i18n.price.price": "Pris",
  "i18n.price.reduction": "Du sparar",
  "i18n.price.total": "Totalsumma",
  "i18n.priceDisplay.times": [
    "{{value}} styck à{{pricePerUnit}}",
    "{{value}} stycken à {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Tillbehör (valfritt)",
  "i18n.progressOverlay.message.lines.one": "Tack för din design",
  "i18n.progressOverlay.message.lines.two": "Vi förbereder följande steg för dig ...",
  "i18n.template.insertText": "Skriv din text här",
  "i18n.toolbox.gallery.title": "Välj foton",
  "i18n.toolbox.image.title": "Redigera foto",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 foto",
    "{{value}} foton"
  ],
  "i18n.toolbox.layout.title": "Byt design",
  "i18n.toolbox.layout.triggerText": "Design",
  "i18n.toolbox.preview.title": "3D-granskning",
  "i18n.toolbox.productChooser.title": "Byt produkt",
  "i18n.toolbox.productChooser.triggerText": "Produkt",
  "i18n.toolbox.text.title": "Redigera text"
};


export class LocaleSvSE {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
